import { makeStyles, Typography } from "@material-ui/core";
import Divider from "@material-ui/core/Divider";
import Badge from "./Badge";

const useStyles = makeStyles((theme) => ({
  description: {
    padding: theme.spacing(2.5, 2.5, 1, 2.5),
  },
  row: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(2.5),
    display: "flex",
    flexWrap: "nowrap",
    overflowX: "auto",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  cardWrapper: {
    minWidth: theme.spacing(0.5),
  },
}));

function BadgeRow(props) {
  const classes = useStyles();
  const badges = props.badgeUnits.slice(1);

  return (
    <>
      <div className={classes.description}>
        <Typography variant="h6" component="h2">
          {props.title}
        </Typography>
        <Typography variant="body2" component="h3">
          {props.description}
        </Typography>
      </div>
      <div className={classes.row}>
        <div className={classes.cardWrapper} />
        {badges.map((item, i) => (
          <div
            key={item.id}
            onClick={() => {
              props.open();
              props.handlePopupID(item.id);
            }}
          >
            <Badge
              icon={props.icon}
              color={props.color}
              badgeAmount={item.amount}
              badgeUnit={item.unit}
              badgeType={props.badgeType}
              achieved={i + 1 <= props.achieved ? true : false}
            />
          </div>
        ))}
        <div className={classes.cardWrapper} />
      </div>
      {!props.noDivider && <Divider />}
    </>
  );
}

export default BadgeRow;
